module.exports = __webpack_public_path__ + "static/media/darts.8b9c8515.svg";